import { createContext } from "react";
import { AttributeAnswer } from "../components/Swiper/Swiper";

const answerResultContext = createContext<{ answers: { [key: string]: boolean } } | undefined>(undefined);

interface AnswerResultProviderProps {
  children: React.ReactNode;
  answers: AttributeAnswer[];
}

const AnswerResultProvider = ({ children, answers }: AnswerResultProviderProps) => {
  const answersMap = answers.reduce(
    (acc, answer) => {
      acc[answer.attributeId] = answer.result;
      return acc;
    },
    {} as { [key: string]: boolean },
  );

  return <answerResultContext.Provider value={{ answers: answersMap }}>{children}</answerResultContext.Provider>;
};

export { answerResultContext, AnswerResultProvider };
